module.exports = __webpack_public_path__ + "static/media/img-moduleC2.3566e198.png";